<img *ngIf="securityImageUri" [src]="securityImageUri" alt="Security Image">
<div *ngIf="!securityImageUri" class="security-image-placeholder"></div>